import React from 'react';
import Styled from 'styled-components';
import { Store } from '../../../../app/js/stores/parent-dashboard';
import { fontQuicksand } from '../../common/mixins/mixin';
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';

const PurchaseCta = ({ clickHandler, titleDuration, fromCreditForm, settings }) => {
  // let ctaText = fromCreditForm ? 'Try for free' : 'Continue';
  // let ctaSubText = fromCreditForm ? '' : `with ${settings.trailDays || 7}-days free trial`;
  let SubText = settings.campaignCode === "miles"?`with ${settings.trailDays}-day free subscription`:`with ${settings.trailDays}-days free trial`;
  let ctaText = settings.trailDays? 'Continue':'Pay now';
  let ctaSubText = settings.trailDays? `${SubText}`:'';
  return (
    <PurchaseBtn
      onClick={(event) => clickHandler(event, titleDuration)}
      inCreditForm={fromCreditForm}
    >
      <p>{ctaText}</p>
      <StyledSpan>{ctaSubText}</StyledSpan>
    </PurchaseBtn>
  );
}
export default PurchaseCta;

export const PurchaseBtn = Styled.a`
  width: 47.2rem;
  height: 6.4rem;
  background-color: #fff;
  ${fontQuicksand(2, 2.6, 7)};
  margin: ${props => props.inCreditForm ? 0 : '10rem'} auto 1rem;
  border-radius: 3.3rem;
  color: #141953;
  border: 0;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  & > p {
    margin: 0 auto;
  }
  &:hover {
    text-decoration: none;
  }
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
    height: 4.8rem;
    ${fontQuicksand(1.6, 2, 7)};
    margin: ${props => props.inCreditForm ? 0 : '4.8rem'} auto 1rem;
  }

  @media ${device.Phone} {
    width: 34rem;
    height: 4.8rem;
    ${fontQuicksand(1.6, 2, 7)};
    margin: ${props => props.inCreditForm ? 0 : '4.8rem'} auto 0rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 37rem;
    ${fontQuicksand(2, 2, 7)};
    margin: ${props => props.inCreditForm ? 0 : '10rem'} auto 2.4rem;
  }
`;
export const StyledSpan = Styled.span`
  ${fontQuicksand(1.3, 1.9, 5)};
`; 